import { Injectable } from '@angular/core';
import { DaysModeEnum } from '../../_enums/days-mode.enum';

@Injectable()
export class DateRangeStrategyManagerService {

  constructor() { }

  public currentSelectedStrategy: DaysModeEnum = DaysModeEnum.WEEK;
  
}
